import React, { useState } from "react";
import PurchaseOrderService from "../../services/PurchaseOrderService/PurchaseOrderService";
import './Modal.css';

const ViewPOEmailModal = ({ isShow, onClose, emailData, userId }) => {
    const [downloading, setDownloading] = useState(false);
    const purchaseOrderService = new PurchaseOrderService();

    if (!isShow || !emailData) return null;

    const handleDownloadPdf = async () => {
        try {
            setDownloading(true);
            const targetUserId = userId || emailData.user_id;
            let exportPayload = {
                order_number: emailData.order_number,
                company_name: emailData.company_name,
                order_date: emailData.order_date,
                total: emailData.total,
                billing_address: emailData.billing_address || "",
                shipping_address: emailData.shipping_address || "",
                sub_total: emailData.sub_total || emailData.total,
                sales_tax: emailData.sales_tax || "0.00"
            };

            if (emailData.id && targetUserId) {
                const detailsRes = await purchaseOrderService.getPurchaseOrderDetails({
                    user_id: targetUserId,
                    order_id: emailData.id
                });
                if (detailsRes?.data?.status === 'success' && detailsRes.data.result) {
                    const { order, items } = detailsRes.data.result;
                    exportPayload = {
                        ...order,
                        sales_data: (items || []).map(item => ({
                            type: item.item_type || "Sale",
                            product_number: item.product_number || "",
                            description: item.description || "",
                            unit_price: item.unit_price || "0",
                            quantity: item.quantity || 0,
                            total_price: item.total_price || "0",
                            multiplier: item.multiplier ?? null,
                            net_price: item.net_price || "0.00"
                        }))
                    };
                }
            }

            const response = await purchaseOrderService.exportPurchaseOrderPDF(exportPayload);
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `purchase-order-${emailData.order_number || 'file'}.pdf`;
            link.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading PDF:", error);
        } finally {
            setDownloading(false);
        }
    };

    return (
        <div className="motor-modal-overlay" onClick={onClose}>
            <div
                className="motor-modal-content"
                style={{ maxWidth: '600px', width: '90%', padding: 0 }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Modal Header */}
                <div className="modal-header-dark">
                    <h4 className="m-0">View Email</h4>
                    <button
                        type="button"
                        className="btn-close btn-close-white"
                        onClick={onClose}
                        aria-label="Close"
                    ></button>
                </div>

                {/* Modal Body */}
                <div className="modal-body-content d-flex flex-column gap-2" style={{ padding: '20px' }}>
                    <div>
                        <strong>From:</strong> webmaster@techtopind.com
                    </div>
                    <div>
                        <strong>To:</strong> {emailData.mail_to || '-'}
                    </div>
                    {emailData.cc_to && (
                        <div>
                            <strong>CC:</strong> {emailData.cc_to}
                        </div>
                    )}
                    <div>
                        <strong>Subject:</strong> Techtop Order Update {emailData.order_number || ''}
                    </div>
                    <div>
                        <strong>Date Sent:</strong> {emailData.order_date || '-'}
                    </div>
                    <div className="d-flex align-items-center gap-1">
                        <strong>Attachment:</strong>
                        <button
                            type="button"
                            className="btn btn-link p-0 text-decoration-underline text-primary fw-semibold d-inline-flex align-items-center gap-1 ms-1"
                            onClick={handleDownloadPdf}
                            disabled={downloading}
                            style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: '14px' }}
                        >
                            <svg width="15" height="15" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z" />
                            </svg>
                            {downloading ? 'Downloading...' : `purchase-order-${emailData.order_number || 'file'}.pdf`}
                        </button>
                    </div>

                    <hr className="my-2" />

                    <div
                        className="p-3 rounded border"
                        style={{
                            backgroundColor: '#f8f9fa',
                            minHeight: '140px',
                            maxHeight: '260px',
                            overflowY: 'auto',
                            whiteSpace: 'pre-wrap',
                            color: '#333',
                            fontSize: '14px',
                            lineHeight: '1.5'
                        }}
                    >
                        {emailData.email_note ? (
                            emailData.email_note.startsWith("Note:") ? (
                                emailData.email_note
                            ) : (
                                `Note: ${emailData.email_note}`
                            )
                        ) : (
                            <span className="text-muted">No email note available.</span>
                        )}
                    </div>
                </div>

                {/* Modal Footer */}
                <div className="modal-footer-dark">
                    <button
                        type="button"
                        className="btn btn-secondary px-4"
                        onClick={onClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewPOEmailModal;
